/**
 * Préfixe un path interne avec /fr ou /en selon la langue active.
 *
 * Règles :
 * - path non-string ou ne commençant pas par "/" → renvoyé tel quel (URLs externes, ancres)
 * - path déjà préfixé /fr/... ou /en/... → renvoyé tel quel (idempotent)
 * - path commençant par /dashboard, /admin, /complete-profile, /checkout → renvoyé tel quel
 *   (zones authentifiées, langue gérée par profile user, pas par URL)
 * - sinon : retourne "/<lang>" + path (ex. "/about" en fr → "/fr/about")
 *
 * Cas spécial "/" : devient "/fr" (pas "/fr/")
 */
const NO_PREFIX_PATHS = ['/dashboard', '/admin', '/complete-profile', '/checkout'];

export function langPath(path, language) {
    if (typeof path !== 'string' || !path.startsWith('/')) return path;
    if (/^\/(fr|en)(\/|$)/.test(path)) return path;
    if (NO_PREFIX_PATHS.some(p => path === p || path.startsWith(p + '/'))) return path;

    const lang = (language === 'en' || language === 'fr') ? language : 'fr';
    return path === '/' ? `/${lang}` : `/${lang}${path}`;
}

/**
 * Strip le préfixe /fr ou /en d'un path. Utile pour switcher de langue
 * en préservant le path courant.
 * Ex. "/fr/about" → "/about", "/en" → "/"
 */
export function stripLangPrefix(path) {
    if (typeof path !== 'string') return path;
    const stripped = path.replace(/^\/(fr|en)(?=\/|$)/, '');
    return stripped === '' ? '/' : stripped;
}
